import request from '@/service/chat'
import qs from 'qs'

// 创建新对话
export const createFeeback = () => {
  return request({
    url: '/chat/createFeeback',
    method: 'GET'
  })
}

// 获取历史记录
export const getHistory = (params: any) => {
  return request({
    url: '/chat/getHistory',
    method: 'GET',
    params
  })
}

// 发送消息
export const sendMsg = (params: any) => {
  return request({
    url: '/chat/sendMsg2',
    method: 'POST',
    data: qs.stringify(params)
  })
}

// 客服回复消息
export const replyMsg = (params: any) => {
  return request({
    url: '/chat/replyMsg2',
    method: 'POST',
    data: qs.stringify(params)
  })
}


// 获取对话状态
export const getFeebackStatus = (params: any) => {
  return request({
    url: '/chat/getFeebackStatus',
    method: 'GET',
    params
  })
}

// 关闭对话
export const closeFeeback = (params: any) => {
  return request({
    url: '/chat/closeFeeback',
    method: 'GET',
    params
  })
}

// 获取未关闭用户对话列表
export const getUserFeebacks = () => {
  return request({
    url: '/chat/getUserFeebacks',
    method: 'GET'
  })
}

export const getPrevHistory = (params: any) => {
  return request({
    url: '/chat/getPrevHistory',
    method: 'GET',
    params
  })
}